export const SIZE = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const THEME = {
    standard: 'standard',
    error: 'error',
    warning: 'warning',
    dark: 'dark',
    neutral: 'neutral',
    success: 'success',
    light: 'light',
    lightOutlined: 'lightOutlined',
};
export const dataHooks = {
    removeButton: 'tag-remove-button',
    text: 'tag-text',
    thumb: 'tag-thumb',
};
export const dataAttr = {
    SIZE: 'data-size',
    DISABLED: 'data-disabled',
    THEME: 'data-theme',
    HOVERABLE: 'data-hoverable',
    CLICKABLE: 'data-clickable',
};
export const tagToTextSize = {
    tiny: 'tiny',
    small: 'small',
    medium: 'small',
    large: 'medium',
};
export const validRemoveKeys = ['Enter', ' '];
//# sourceMappingURL=Tag.constants.js.map